import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import TableEditorRteHeader from './TableEditorRteHeader';
import TableEditorRteRow from './TableEditorRteRow';
import PopoverMenu from '../../misc/PopoverMenu';
import Button from '../../misc/Button';

import ThemeIcons from '../../../theme/Icons';
import ThemeContext from '../../../theme/ThemeContext';

const StyledTable = styled.div`
  display: flex;
  overflow: auto;
  flex-direction: column;
`;

const StyledFooter = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
  margin: 8px;
`;

const StyledAddIcon = styled.span`
  &:hover {
    cursor: pointer;
  }
`;

class TableEditorRte extends PureComponent {

  static contextType = ThemeContext

  static propTypes = {
    id: PropTypes.string,
    fieldId: PropTypes.string,
    activeFieldPosition: PropTypes.object,
    onRteSettingsCreate: PropTypes.func,
    onRteSettingsUpdate: PropTypes.func,
    onRteSettingsMoveLeft: PropTypes.func,
    onRteSettingsMoveRight: PropTypes.func,
    onRteSettingsDelete: PropTypes.func,
  }

  constructor(props) {
    super(props);
    this.state = {
      displayAddColumnPopover: false,
    };
  }

  handleColumnCreate = () => {
    const { onRteSettingsCreate, fieldId } = this.props;
    if (onRteSettingsCreate) onRteSettingsCreate(fieldId);
    this.setState({ displayAddColumnPopover: false });
  }

  handleColumnUpdate = (settingId, patch) => {
    const { onRteSettingsUpdate, fieldId } = this.props;
    if (onRteSettingsUpdate) onRteSettingsUpdate(fieldId, settingId, patch);
  }

  handleColumnMoveLeft = (settingId) => {
    const { onRteSettingsMoveLeft, fieldId } = this.props;
    if (onRteSettingsMoveLeft) onRteSettingsMoveLeft(fieldId, settingId);
  }

  handleColumnMoveRight = (settingId) => {
    const { onRteSettingsMoveRight, fieldId } = this.props;
    if (onRteSettingsMoveRight) onRteSettingsMoveRight(fieldId, settingId);
  }

  handleColumnDelete = (settingId) => {
    const { onRteSettingsDelete, fieldId } = this.props;
    if (onRteSettingsDelete) onRteSettingsDelete(fieldId, settingId);
  }

  render() {

    const { id, activeFieldPosition } = this.props;
    const { displayAddColumnPopover } = this.state;
    const rteColumns = activeFieldPosition?.settings || [];
    const hasColumns = rteColumns.length > 0;

    const popoverItems = [
      {
        text: 'Add Column',
        icon: { icon: ThemeIcons.misc.add, size: 'sm' },
        onClick: () => this.handleColumnCreate(),
      },
    ];

    return (
      <>
        {hasColumns ? (
          <StyledTable data-testid={`${id}-rte-editor-table`}>
            <TableEditorRteHeader
              id={id}
              rteColumns={rteColumns}
              onBlur={this.handleColumnUpdate}
              onMoveLeft={this.handleColumnMoveLeft}
              onMoveRight={this.handleColumnMoveRight}
              onDelete={this.handleColumnDelete}
            />
            <TableEditorRteRow
              id={id}
              rteColumns={rteColumns}
              onBlur={this.handleColumnUpdate}
            />
          </StyledTable>
        ) : null}
        <StyledFooter>
          <PopoverMenu
            reposition={false}
            isOpen={displayAddColumnPopover}
            positions={['top']}
            padding={18}
            onClickOutside={() => this.setState({ displayAddColumnPopover: false })}
            items={popoverItems}
          >
            <StyledAddIcon>
              <Button
                icon={ThemeIcons.misc.add}
                onClick={(e) => {
                  if (e) e.stopPropagation();
                  this.setState({ displayAddColumnPopover: !displayAddColumnPopover });
                }}
              />
            </StyledAddIcon>
          </PopoverMenu>
        </StyledFooter>
      </>
    );

  }

}

export default TableEditorRte;
